import React from "react"
import { Typography } from "@mui/material"
import { isNull } from "lodash"
import {
  isOpen,
  parseOpeningHours,
  findNextOpeningTime,
  findCurrentDateName,
  findTodayOperatingTime,
} from "utils/date"
import { useTranslation } from "providers/i18n"

export const OpeningInfo = ({ hours }) => {
  const { t } = useTranslation()
  const openingHours = parseOpeningHours(hours)
  if (isNull(openingHours)) return null
  const isOpening = isOpen(openingHours)
  const { close } = findTodayOperatingTime(openingHours) || {}
  const { open, day } = findNextOpeningTime(openingHours)
  const currentDate = findCurrentDateName()
  const dayToOpen = day.toLowerCase() === currentDate ? "" : day
  const openText = t("Open")
  const closeText = t("Close")
  const openingStatus = isOpening ? openText : closeText
  const nextOpeningStatus = openingStatus === closeText ? openText : closeText

  return (
    <Typography variant="body2">
      {openingStatus} ·{" "}
      <Typography variant="inherit" component="span" color="text.secondary">
        {nextOpeningStatus} {dayToOpen} {isOpening ? close : open}
      </Typography>
    </Typography>
  )
}
